"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = require("./styled");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Background =
/*#__PURE__*/
function (_Component) {
  _inherits(Background, _Component);

  function Background(props) {
    var _this;

    _classCallCheck(this, Background);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Background).call(this, props));
    _this.state = {
      loaded: false
    };
    return _this;
  }

  _createClass(Background, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setImage(this.props.url);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(prevProps, nextState) {
      var loaded = nextState.loaded !== this.state.loaded;
      var imgAdded = prevProps.url !== this.props.url;
      return loaded || imgAdded;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var url = this.props.url;

      if (prevProps.url !== url && url) {
        this.setImage(url);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "setImage",
    value: function setImage(url) {
      var _this2 = this;

      if (url && url.length) {
        clearTimeout(this.timeout);
        var image = new Image();

        image.onload = function () {
          return _this2.handleImgLoaded();
        };

        image.src = url;
      }
    }
  }, {
    key: "handleImgLoaded",
    value: function handleImgLoaded() {
      this.timeout = setTimeout(this.setState.bind(this, {
        loaded: true
      }), 200);
    }
  }, {
    key: "render",
    value: function render() {
      var loaded = this.state.loaded;
      var _this$props = this.props,
          url = _this$props.url,
          showGradient = _this$props.showGradient,
          color = _this$props.color,
          opacity = _this$props.opacity;
      var imgStyle = {
        backgroundImage: "url('".concat(url, "')"),
        opacity: loaded ? 1 : 0
      };
      return _react["default"].createElement(_styled.SmartBackground, {
        showGradient: showGradient,
        background: color
      }, _react["default"].createElement("div", {
        className: "smartImage",
        style: imgStyle
      }), _react["default"].createElement(_styled.Overlay, {
        opacity: opacity,
        showGradient: showGradient
      }));
    }
  }]);

  return Background;
}(_react.Component);

var _default = Background;
exports["default"] = _default;

//# sourceMappingURL=Background.js.map